'use client';

import { useTheme } from 'next-themes';
import { HTMLAttributes } from 'react';
import { twMerge } from 'tailwind-merge';

export default function ThemeSwitcher(props?: Partial<HTMLAttributes<HTMLElement>>) {
  const { theme, setTheme } = useTheme();
  const isDark = theme === 'dark';
  return (
    // <div className='cursor-pointer grid place-items-center w-fit bg-danger' {...props} onClick={() => setTheme(isDark ? 'light' : 'dark')}>

<button
dir='ltr'
{...props}
onClick={() => setTheme(isDark ? 'light' : 'dark')}
      // Fixed width (w-14) and height (h-7)
      className={twMerge(`relative flex items-center w-14 h-7 desktop:w-7 desktop:dark:bg-quinary desktop:bg-gray-0 rounded-full p-1 transition-all duration-300`,isDark ? 'bg-quaternary' : 'bg-gray-0', props?.className)}

    >
      {/* The Moving Knob */}
      <div
        className={twMerge(`
          flex h-5 w-5 items-center justify-center rounded-full bg-white desktop:bg-transparent shadow-sm 
          transition-all duration-300 ease-in-out transform [&>*]:!h-[16px] [&>*]:!w-[16px]`,
          !isDark ? 'translate-x-7 desktop:translate-x-[unset]' : 'translate-x-0 desktop:translate-x-[unset]'
        )}
      >
        {isDark ? <Sun/> : <Moon/>}
      </div>
    </button>
  )
}

{/* <Switch checked={!isDark} size={60} className='!w-full'/> */}
  {/* {isDark ?  <Moon/> : <Crescent/> } */}
// </div>



function Sun() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z" className='stroke-black desktop:stroke-white' strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M12 2V4" className='stroke-black desktop:stroke-white' strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M12 20V22" className='stroke-black desktop:stroke-white' strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M4.92999 4.93L6.33999 6.34" className='stroke-black desktop:stroke-white' strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M17.66 17.66L19.07 19.07" className='stroke-black desktop:stroke-white' strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M2 12H4" className='stroke-black desktop:stroke-white' strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M20 12H22" className='stroke-black desktop:stroke-white' strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M6.33999 17.66L4.92999 19.07" className='stroke-black desktop:stroke-white' strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M19.07 4.93L17.66 6.34" className='stroke-black desktop:stroke-white' strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
</svg>
  )
}


function Moon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M20.985 12.486C20.8913 14.2221 20.2967 15.894 19.2731 17.2994C18.2495 18.7048 16.8407 19.7837 15.217 20.4055C13.5934 21.0274 11.8244 21.1656 10.1238 20.8035C8.42325 20.4414 6.86398 19.5945 5.63449 18.3652C4.40499 17.1358 3.55791 15.5766 3.19564 13.8761C2.83337 12.1756 2.97142 10.4065 3.5931 8.78282C4.21478 7.15909 5.29348 5.75019 6.6988 4.72644C8.10412 3.70268 9.77589 3.10791 11.512 3.014C11.917 2.992 12.129 3.474 11.914 3.817C11.1949 4.96755 10.887 6.32787 11.0405 7.67595C11.194 9.02403 11.7999 10.2803 12.7593 11.2397C13.7187 12.1991 14.975 12.805 16.3231 12.9585C17.6712 13.112 19.0315 12.8041 20.182 12.085C20.526 11.87 21.007 12.081 20.985 12.486Z" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
</svg>

  )
}